<template>
<div >
  <div class="row">
        <div class="flex xs12 sm12 lg9">
          <h1>{{ $t('gestaocurso.Matriculas') }}</h1>
        </div>
        <div class="flex xs12 sm12 lg3">
          <va-button class="text-right" @click="abrirNovo()"  :color="BuNovo.color" :style="BuNovo"> {{ $t('Geral.Novo') }}</va-button>
        </div>
  </div>

  <div v-if="novo">
          <form @submit.prevent="addMatricula()" >
              <div class="row">
                 <div class="flex md3 sm12 xs12">
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="polo"
                      textBy="nome"
                      :options="allPolos"
                      placeholder="Polos"
                    />
                  </div>

                  <div class="flex md3 sm12 xs12">
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="matricula.oferta_grade_polo"
                      textBy="nome_curso"
                      :options="AllCursosLiberadosPolo"
                      placeholder="Cursos abilitados"
                    />
                  </div>
                   <div class="flex md3 sm12 xs12">
                  <va-input
                  :label="$t('forms.selects.simple')"
                    v-model="matricula.descricao"
                    placeholder="Descricao"
                  />
                </div>
                <div class="flex md3 sm12 xs12 text-center">
                    <va-button class="text-right"  color="dark"> {{ $t('Geral.Salvar') }}</va-button>
                </div>
              </div>

          </form>

  </div>
 
    <va-data-table
          :fields="fields"
          :data="AllMatriculaAluno"
          hoverable
          no-pagination
          >
              <template slot="marker" slot-scope="props">
                <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
              </template>

              <template slot="actions" slot-scope="props">
                <va-button flat small color="gray" @click="edit(props.rowData)" class="ma-0">
                  {{ $t('tables.edit') }}
                </va-button>

                <va-button flat small color="danger" @click="remove(props.rowData)" class="ma-0">
                  {{ $t('tables.delete') }}
                </va-button>
              </template>
              
        </va-data-table>

   

</div>

      
 
</template>

<script>
//import cursos from './Cursos'

export default {
  name: 'matriculaaluno',
  
  components: {
  
  },

  data () {
      return {
      
        BuNovo: {
          color:'info',
          'width': '100%',
        }, 
        matricula: {
         
          aluno_id:this.$store.state.alunos.get_aluno.id,
          oferta_grade_polo: '',
          descricao:''

        },
        polo:{
          id:''
        },
        novo: false,
     
      }
    },
    created(){
      this.all();
    },
  computed: {
    
    AllMatriculaAluno (){ return   this.$store.state.alunos.allmatriculaaluno },

    allPolos(){ return   this.$store.state.polos.allpolos},
    AllCursosLiberadosPolo(){ 
        if (this.polo.id != '') {
          this.$store.dispatch('cursosOfertaPolo',this.polo.id)
          this.polo.id = ''
        
        }
        return this.$store.state.polos.polosselecionados
    },

    fields () {
        return [{
          name: '__slot:marker',
          width: '30px',
          dataClass: 'text-center',
        }, {
          name: 'nome_curso',
          title: this.$t('tables.headings.name'),
        }, {
          name: 'nome_tipo_curso',
          title: this.$t('tables.headings.email'),
        }, {
          name: 'nome_polo',
          title: this.$t('tables.headings.country'),
        },{
          name: 'created_at',
          dataClass: 'text-right',
          title: this.$t('tables.headings.country'),
         
        }, {
          name: '__slot:actions',
          dataClass: 'text-right',
        }]
    },
  },

  methods: {
    all(){
      this.$store.dispatch('allPolo')
      this.$store.dispatch('allMatriculaAluno',this.$store.state.alunos.get_aluno.id)

    },
  async  addMatricula(){
      
      this.$store.dispatch('AddMatriculaAluno',this.matricula)
      this.all()
      this.abrirNovo()
    },
      abrirNovo (){
        this.novo = !this.novo
    },
 
  },
}
</script>

<style lang="scss">

</style>
